(function () {
  function initRoot(root) {
    if (!root || root.dataset.erReady === 'true') {
      return;
    }

    root.dataset.erReady = 'true';

    /* =================================
       Mobile layout
    ================================= */

    function updateMobileLayout() {
      root.classList.toggle(
        'is-mobile',
        window.innerWidth <= 768
      );
    }

    updateMobileLayout();

    window.addEventListener(
      'resize',
      updateMobileLayout,
      { passive: true }
    );

    window.addEventListener(
      'orientationchange',
      updateMobileLayout,
      { passive: true }
    );

    /* =================================
       Reveal-on-scroll animation
    ================================= */

    if ('IntersectionObserver' in window) {
      root.classList.add('js-armed');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15
        }
      );

      root
        .querySelectorAll('.er-reveal')
        .forEach(function (element) {
          observer.observe(element);
        });
    }

    /* Only the Hero controls the countdown,
       text changes, Brevo form and all buttons. */

    if (!root.classList.contains('er-hero-root')) {
      return;
    }

    /* =================================
       Hero launch settings
    ================================= */

    var launchDate = new Date(
      root.dataset.launchDate
    ).getTime();

    var signupLabel =
      root.dataset.signupLabel || 'Sign Up';

    var buyLabel =
      root.dataset.buyLabel || 'Buy Now';

    var liveLabel =
      root.dataset.liveLabel || 'Now Live';

    var productUrl =
      root.dataset.productUrl || '#';

    var hideExpiredTimer =
      root.dataset.hideExpiredTimer === 'true';

    /* =================================
       Before-launch text
    ================================= */

    var beforeBadge =
      root.dataset.beforeBadge || '';

    var beforeHeading =
      root.dataset.beforeHeading || '';

    var beforeOffer =
      root.dataset.beforeOffer || '';

    var beforeEyebrow =
      root.dataset.beforeEyebrow || '';

    /* =================================
       After-launch text
    ================================= */

    var afterBadge =
      root.dataset.afterBadge || beforeBadge;

    var afterHeading =
      root.dataset.afterHeading || beforeHeading;

    var afterOffer =
      root.dataset.afterOffer || beforeOffer;

    var afterEyebrow =
      root.dataset.afterEyebrow || beforeEyebrow;

    /* =================================
       Hero elements
    ================================= */

    var timers = root.querySelectorAll(
      '.hero-timer'
    );

    var dialog = root.querySelector(
      '.er-signup-dialog'
    );

    var countdownInterval = null;

    /* Get the Hero and Kingpin buttons.
       This runs each time so dynamically
       loaded Shopify sections also work. */

    function getLaunchButtons() {
      return document.querySelectorAll(
        '.js-er-launch-button, ' +
        '.js-er-linked-launch-button'
      );
    }

    /* =================================
       General helpers
    ================================= */

    function updateAll(selector, value) {
      root
        .querySelectorAll(selector)
        .forEach(function (element) {
          element.textContent = value;
        });
    }

    function pad(number) {
      return number < 10
        ? '0' + number
        : String(number);
    }

    function updateHeroText(
      badge,
      heading,
      offer,
      eyebrow
    ) {
      updateAll(
        '.js-er-badge',
        badge
      );

      updateAll(
        '.js-er-heading',
        heading
      );

      updateAll(
        '.js-er-offer',
        offer
      );

      updateAll(
        '.js-er-eyebrow',
        eyebrow
      );
    }

    /* =================================
       Timer visibility
    ================================= */

    function showTimers() {
      timers.forEach(function (timer) {
        timer.hidden = false;
        timer.style.removeProperty('display');
      });
    }

    function hideTimers() {
      timers.forEach(function (timer) {
        timer.hidden = true;

        timer.style.setProperty(
          'display',
          'none',
          'important'
        );
      });
    }

    /* =================================
       Offer disclaimer visibility
    ================================= */

    function showOfferDisclaimer() {
      root
        .querySelectorAll('.er-offer-disclaimer')
        .forEach(function (disclaimer) {
          disclaimer.hidden = false;
          disclaimer.style.removeProperty('display');
        });
    }

    function hideOfferDisclaimer() {
      root
        .querySelectorAll('.er-offer-disclaimer')
        .forEach(function (disclaimer) {
          disclaimer.hidden = true;
          disclaimer.style.setProperty(
            'display',
            'none',
            'important'
          );
        });
    }

    /* =================================
       Brevo signup form
    ================================= */

    function openSignupForm(event) {
      if (event) {
        event.preventDefault();
      }

      if (!dialog) return;

      if (
        typeof dialog.showModal === 'function'
      ) {
        if (!dialog.open) {
          dialog.showModal();
        }
      } else {
        dialog.setAttribute('open', '');
      }

      document.body.classList.add(
        'er-form-open'
      );
    }

    function closeSignupForm() {
      if (!dialog) return;

      if (
        typeof dialog.close === 'function' &&
        dialog.open
      ) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }

      document.body.classList.remove(
        'er-form-open'
      );
    }

    /* =================================
       Before launch
    ================================= */

    function activateSignup() {
      var buttons = getLaunchButtons();

      root.classList.remove('is-launched');

      showOfferDisclaimer();

      /* Restore before-launch Hero text. */

      updateHeroText(
        beforeBadge,
        beforeHeading,
        beforeOffer,
        beforeEyebrow
      );

      /* Make countdown visible. */

      showTimers();

      /* Change all Hero and Kingpin
         buttons to Sign Up. */

      buttons.forEach(function (button) {
        button.textContent = signupLabel;

        button.href =
          '#er-signup-' +
          root.dataset.sectionId;

        button.dataset.mode = 'signup';
      });

      root.dataset.launchStatus = 'before';
    }

    /* =================================
       After launch
    ================================= */

    function activateProduct() {
      var buttons = getLaunchButtons();

      root.classList.add('is-launched');

      hideOfferDisclaimer();

      /* Change desktop and mobile Hero text. */

      updateHeroText(
        afterBadge,
        afterHeading,
        afterOffer,
        afterEyebrow
      );

      /* Update timer label before hiding it. */

      updateAll(
        '.hero-timer .timer-label',
        liveLabel
      );

      /* Hide both desktop and mobile timers. */

      if (hideExpiredTimer) {
        hideTimers();
      }

      /* Change all Hero and Kingpin
         buttons to Buy Now. */

      buttons.forEach(function (button) {
        button.textContent = buyLabel;
        button.href = productUrl;
        button.dataset.mode = 'buy';
      });

      root.dataset.launchStatus = 'after';
    }

    /* =================================
       Countdown
    ================================= */

    function updateCountdown() {
      var difference =
        launchDate - Date.now();

      if (difference <= 0) {
        updateAll('.js-days', '00');
        updateAll('.js-hours', '00');
        updateAll('.js-mins', '00');
        updateAll('.js-secs', '00');

        activateProduct();

        return false;
      }

      activateSignup();

      var days = Math.floor(
        difference / 86400000
      );

      var hours = Math.floor(
        (difference % 86400000) /
        3600000
      );

      var minutes = Math.floor(
        (difference % 3600000) /
        60000
      );

      var seconds = Math.floor(
        (difference % 60000) /
        1000
      );

      updateAll(
        '.js-days',
        pad(days)
      );

      updateAll(
        '.js-hours',
        pad(hours)
      );

      updateAll(
        '.js-mins',
        pad(minutes)
      );

      updateAll(
        '.js-secs',
        pad(seconds)
      );

      return true;
    }

    /* =================================
       Hero and Kingpin button clicks
    ================================= */

    function handleLaunchButtonClick(event) {
      var clickedElement = event.target;

      if (
        clickedElement &&
        clickedElement.nodeType === 3
      ) {
        clickedElement =
          clickedElement.parentElement;
      }

      if (
        !clickedElement ||
        !clickedElement.closest
      ) {
        return;
      }

      var button = clickedElement.closest(
        '.js-er-launch-button, ' +
        '.js-er-linked-launch-button'
      );

      if (!button) return;

      if (button.dataset.mode === 'signup') {
        openSignupForm(event);
      }
    }

    document.addEventListener(
      'click',
      handleLaunchButtonClick
    );

    /* =================================
       Close form button
    ================================= */

    root
      .querySelectorAll('[data-er-close]')
      .forEach(function (closeButton) {
        closeButton.addEventListener(
          'click',
          closeSignupForm
        );
      });

    /* =================================
       Dialog events
    ================================= */

    if (dialog) {
      /* Close when clicking the backdrop. */

      dialog.addEventListener(
        'click',
        function (event) {
          if (event.target === dialog) {
            closeSignupForm();
          }
        }
      );

      /* Restore page scrolling if the
         browser closes the dialog. */

      dialog.addEventListener(
        'close',
        function () {
          document.body.classList.remove(
            'er-form-open'
          );
        }
      );
    }

    /* Close using Escape. */

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          dialog &&
          dialog.open
        ) {
          closeSignupForm();
        }
      }
    );

    /* =================================
       Start countdown
    ================================= */

    if (isNaN(launchDate)) {
      /* Keep signup active if the date
         entered in Shopify is invalid. */

      activateSignup();
      return;
    }

    if (updateCountdown()) {
      countdownInterval = setInterval(
        function () {
          /* Stop if Shopify removes the
             Hero section from the page. */

          if (
            !document.documentElement.contains(root)
          ) {
            clearInterval(countdownInterval);

            document.removeEventListener(
              'click',
              handleLaunchButtonClick
            );

            return;
          }

          if (!updateCountdown()) {
            clearInterval(countdownInterval);
          }
        },
        1000
      );
    }
  }

  /* =================================
     Initialize all El Ruso sections
  ================================= */

  function initAll(scope) {
    var container = scope || document;

    if (
      container.matches &&
      container.matches('.er-lp')
    ) {
      initRoot(container);
    }

    container
      .querySelectorAll('.er-lp')
      .forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  /* =================================
     Shopify Theme Editor reload
  ================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);

      var hero = document.querySelector(
        '.er-hero-root'
      );

      if (!hero) return;

      /* Synchronize a newly loaded Kingpin
         button with the current Hero state. */

      var linkedButtons =
        document.querySelectorAll(
          '.js-er-linked-launch-button'
        );

      var signupLabel =
        hero.dataset.signupLabel || 'Sign Up';

      var buyLabel =
        hero.dataset.buyLabel || 'Buy Now';

      var productUrl =
        hero.dataset.productUrl || '#';

      var launchDate = new Date(
        hero.dataset.launchDate
      ).getTime();

      var isLive =
        !isNaN(launchDate) &&
        launchDate <= Date.now();

      linkedButtons.forEach(function (button) {
        if (isLive) {
          button.textContent = buyLabel;
          button.href = productUrl;
          button.dataset.mode = 'buy';
        } else {
          button.textContent = signupLabel;

          button.href =
            '#er-signup-' +
            hero.dataset.sectionId;

          button.dataset.mode = 'signup';
        }
      });
    }
  );
})();
